import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import BoardAndTrains from './pages/BoardAndTrains';
import InHomePrograms from './pages/InHomePrograms';
import PuppyProgram from './pages/PuppyProgram';
import FeralDogRehab from './pages/FeralDogRehab';
import CityDogBoardTrain from './pages/CityDogBoardTrain';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import { Toaster } from './components/ui/sonner';
import FloatingBookButton from './components/FloatingBookButton';

function App() {
  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/board-and-trains" element={<BoardAndTrains />} />
              <Route path="/in-home-programs" element={<InHomePrograms />} />
              <Route path="/puppy-program" element={<PuppyProgram />} />
              <Route path="/feral-dog-rehab" element={<FeralDogRehab />} />
              <Route path="/city-dog-board-train" element={<CityDogBoardTrain />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <FloatingBookButton />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;